import React from 'react';

import CompanyInfoSection from 'js/src/components/public-pages/common-sections/CompanyInfoSection';
import type { ImmutableMap } from 'js/src/libs/consts';

const CaseStudyComponent = React.memo(function CaseStudyComponent({
    data,
    bgColor,
    lazyLoad,
}: {
    data: ImmutableMap<{
        title?: string; // Optional field for Contentful (not used, but required to create content model)
    }>;
    bgColor: string;
    lazyLoad: boolean;
}) {
    return (
        <div className="contentful-component case-study" style={{ backgroundColor: bgColor }}>
            <div className="container">
                <CompanyInfoSection />
            </div>
        </div>
    );
});

export default CaseStudyComponent;
